import classNames from "classnames/bind";
import * as React from "react";
import styles from "./Tag.module.css";

const classNameBuilder = classNames.bind(styles);

interface Props {
  name: string;
  color?: "success" | "primary";
}

export const Tag: React.FC<React.PropsWithChildren<Props>> = ({
  name,
  color = "primary",
}) => {
  const classes = classNameBuilder({
    container: true,
    primary: color === "primary",
    success: color === "success",
  });

  return <div className={classes}>{name}</div>;
};
